<template>
  <div>
    <layout-head v-if="code==='001'" :navActive="2"></layout-head>
    <layout-head v-if="code==='002'" :navActive="4"></layout-head>
    <layout-head v-if="code==='003'" :navActive="1"></layout-head>
    <layout-head v-if="code!=='001' && code!=='002' && code!=='003'" :navActive="0"></layout-head>
    <div class="topic_details_container">
      <div class="warp12">
        <div class="topic_list_nav">
          <div class="bread">
            <el-breadcrumb separator-class="el-icon-arrow-right">
              <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
              <el-breadcrumb-item v-if="code==='001'" :to="{ path: '/multimedia' }">多媒体矩阵</el-breadcrumb-item>
              <el-breadcrumb-item v-if="code==='002'" :to="{ path: '/pictorialMatter' }">解图知事</el-breadcrumb-item>
              <el-breadcrumb-item>{{obj.fileName}}</el-breadcrumb-item>
            </el-breadcrumb>
          </div>
          <div class="search_container">
            <el-input v-model.trim="searText" placeholder="搜索你想知道的" @keyup.enter.native="checkList"></el-input>
            <img src="@/assets/image/index/search_btn.png" alt class="search_btn" @click="checkList" />
          </div>
        </div>
        <div class="details_container">
          <div class="details_l">
            <el-image
            v-if="code == '001'"
              :src="obj.coverUrl" @click="goVideo" class="details_l_img">
            </el-image>
            <el-image
            v-if="code == '002'"
              :src="obj.pictureUrl"
              :preview-src-list="[obj.pictureUrl]">
            </el-image>
          </div>
          <div class="details_r">
            <div class="details_r_t">
              <div class="title" :title="obj.fileName" @click="goVideo">{{obj.fileName}}</div>
            <div class="line">
              <p class="line_l">分类：</p>
              <div class="line_r">{{obj.theme}}</div>
            </div>
            </div>
            <!-- <div class="line">
              <p class="line_l">标签：</p>
              <div class="line_r line_r_bq">
                <div class="bq_item">生态环境</div>
                <div class="bq_item">海洋环境</div>
                <div class="bq_item">塑料</div>
              </div>
            </div> -->
            <!-- <div class="line">
              <p class="line_l">声明：</p>
              <div
                class="line_r sm"
              >所有原创作品（含预览图）均受著作权法保护。著作权及相关权利归本公司所有，未经许可任何人不得擅自使用，否则将依法要求承担一定赔偿责任。</div>
            </div> -->
            <div class="line last_line" v-if="obj.brief">
              <p class="line_l">简介：</p>
              <div class="line_r">
                {{obj.brief }}
                <!-- <p>塑料在当今社会中占有举足轻重的地位，被广泛应用于商业、工业、医药和市政等领域。随着中国工业化进程的不断加快，中国已成为全球塑料产量最大的国家。</p>
                <p>塑料工业的发展在给人类社会生活、生产带来方便的同时，也导致大量的废旧塑料垃圾不断产生。由于塑料的持久性和普遍性，塑料垃圾正在破坏、威胁着海洋环境，更可怕的是，它已经开始渐渐地进入食物链，严重影响到海洋生态系统的健康和可持续发展。</p>
                <p>海洋塑料污染跨越了国家和区域界限，是一个复杂的全球性环境问题。尽管国际社会和一些国家为防止和减少废弃塑料等海洋垃圾做出了不懈努力，但这一问题仍在加剧。因此，加强海洋塑料污染防治十分重要。</p>
                <p>1.加强对塑料垃圾的来源管理。制定更为严格的塑料产品管理标准和规范；持续提高民众减少塑料垃圾的参与意识；增加法律条款来限制向环境中排放塑料垃圾的行为。</p>
                <p>2.推动建立海洋塑料污染问题的国际联合行动机制。各国政府应加强联合行动，通过相关的区域海洋公约和河流委员会开展合作，共同处理海洋中的塑料垃圾。</p>
                <p>3.我国应重视并加强海洋塑料垃圾的管理和研究。加强海事监管及船舶垃圾管理，严控违法排放，并鼓励科研人员开展环境塑料污染行为研究。</p>
                <p
                  class="blue"
                >参考文献：廖琴,曲建升,王金平,高峰.世界海洋环境中的塑料污染现状分析及治理建议[J].世界科技研究与发展,2015,37(02):206-211+217.</p> -->
              </div>
            </div>
          </div>
        </div>
        <div class="commond_mh">
          <div class="blue_title">
            <h2>推荐{{code==='001'?'动漫':'漫画'}}</h2>
            <a class="blue_title_more" @click="goTopicList(obj.theme)">查看更多 +</a>
          </div>
          <div class="mh_lst">
            <div class="mh_item" v-for="(item,index) in mhList" :key="index" @click="goDetails(item.fileID)">
              <img :src="item.coverUrl" class="mh_img" alt />
              <div class="mh_bottom">
                <h3 :title="item.fileName">{{item.fileName}}</h3>
                <div class="ll">
                  <p>
                    <img src="@/assets/image/multimedia/chakan.png" alt />
                    {{ item.visitCount }}
                  </p>
                  <p>{{ item.theme }}</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <layout-footer></layout-footer>
  </div>
</template>

<script>
import layoutHead from '@/components/Header'
import layoutFooter from '@/components/Footer'
import { getData, updateVisitCount } from '@/assets/js/api'
export default {
  name: 'topicDetailsPage',
  components: { layoutHead, layoutFooter },
  data () {
    return {
      searText: '',
      topicId: '',
      mhList: [],
      code: '',
      obj: {}
    }
  },
  watch: {
    $route: {
      handler (route) {
        this.topicId = this.$route.query.id
        this.code = this.$route.query.code
        const params = {
          fileID: this.topicId,
          code: this.code
        }
        getData(params).then((res) => {
          if (res.code === '200') {
            this.obj = res.content.data[0]
            this.getCommondList()
          }
        })
        this.updateData()
      }
    }
  },
  created () {
    this.topicId = this.$route.query.id
    this.code = this.$route.query.code
    const params = {
      fileID: this.topicId,
      code: this.code
    }
    getData(params).then((res) => {
      if (res.code === '200') {
        this.obj = res.content.data[0]
        this.getCommondList()
      }
    })
    this.updateData()
  },
  methods: {
    getCommondList () {
      getData({
        code: this.code,
        theme: this.obj.theme,
        size: 4
      }).then((res) => {
        if (res.code === '200') {
          this.mhList = res.content.data
        }
      })
    },
    goDetails (id) {
      this.$router.push({
        name: 'topicDetails',
        query: {
          id: id,
          code: this.code
        }
      })
    },
    goTopicList (item) {
      this.$router.push({
        name: 'topic',
        query: {
          item: item,
          code: this.code
        }
      })
    },
    goVideo () {
      this.$router.push({
        name: 'video',
        query: {
          id: this.topicId
        }
      })
    },
    checkList () {
      this.$router.push({
        name: 'topic',
        query: {
          item: '全部',
          code: this.code,
          searText: this.searText
        }
      })
    },
    updateData () {
      const params = {
        fileID: this.topicId,
        code: this.code
      }
      updateVisitCount(params).then((res) => {
        if (res.code === '200') {
          console.log(res)
        }
      })
    }
  }
}
</script>

<style lang="less" scoped>
.topic_details_container {
  margin-top: -387px;
  padding-bottom: 44px;
  .topic_list_nav {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 26px;
    .bread {
    }
    .search_container {
      width: 342px;
      margin: 0;
    }
  }
  .details_container {
    display: flex;
    align-items: flex-start;
    justify-content: space-between;
    margin-bottom: 60px;

    .details_l {
      width: 547px;
      height: auto;
      max-height: 293px;
      overflow-y: scroll;
      box-shadow: 0px 0px 20px 0px rgba(2, 39, 102, 0.2);
      .details_l_img {
        cursor: pointer;
      }
      img {
        display: block;
        width: 100%;
        height: 100%;
      }
    }

    .details_r {
      width: 620px;
      .details_r_t {
        min-height: 255px;
      }

      .title {
        font-size: 24px;
        color: #ffffff;
        margin-bottom: 30px;
        font-weight: bold;
        cursor: pointer;
      }

      .line {
        display: flex;
        align-items: flex-start;
        margin-bottom: 31px;

        .line_l {
          width: 60px;
          font-size: 18px;
          color: #ffffff;
          font-weight: bold;
        }

        .line_r {
          flex: 1;
          font-size: 16px;
          color: #ffffff;

          &.line_r_bq {
            display: flex;
            align-items: center;

            .bq_item {
              width: 122px;
              height: 46px;
              background: url(@/assets/image/multimedia/bq1.png) no-repeat
                center center;
              background-size: 100%;
              display: flex;
              justify-content: center;
              align-items: center;
              font-size: 18px;
              margin-right: 18px;

              &:nth-child(2) {
                background: url(@/assets/image/multimedia/bq2.png) no-repeat
                  center center;
              }

              &:nth-child(3) {
                background: url(@/assets/image/multimedia/bq3.png) no-repeat
                  center center;
              }
            }
          }

          &.sm {
            line-height: 26px;
          }
        }

        &.last_line {
          margin-top: 60px;
          margin-bottom: 0;

          .line_l {
            color: #333333;
          }

          .line_r {
            color: #333333;
            font-size: 14px;
            line-height: 34px;
          }
        }
      }
    }
  }

  .mh_lst {
    display: flex;
    justify-content: space-between;
    align-items: center;

    .mh_item {
      width: 260px;
      cursor: pointer;
      .mh_img {
        display: block;
        width: 100%;
        height: 140px;
        border: 1px solid #ffffff;
        box-shadow: 0px 0px 20px 0px rgba(2, 39, 102, 0.2);
        margin-bottom: 24px;
      }

      .mh_bottom {
        h3 {
          color: #333333;
          font-weight: normal;
          font-size: 16px;
          text-overflow: ellipsis;
    overflow: hidden;
    white-space: nowrap;
        }

        .ll {
          display: flex;
          justify-content: space-between;
          align-items: center;
          margin-top: 10px;

          p {
            font-size: 14px;
            color: #666666;

            img {
              display: inline-block;
              vertical-align: middle;
              margin-right: 11px;
            }
          }
        }
      }
    }
  }
}
</style>
